import React from "react";
import { useRecordContext } from "react-admin";

type CanSelfInspectFieldProps = {
  sortable?: boolean;
  source: string;
};

export const CanSelfInspectField = (props: CanSelfInspectFieldProps) => {
  const { ...rest } = props;
  const record = useRecordContext();

  if (record === undefined) {
    return null;
  }

  const isSelfInspect: boolean = record[props.source];

  return <span {...rest}>{isSelfInspect ? "可能" : "不可能"}</span>;
};
